import { useEffect, useRef } from 'react';

const specs = [
  { icon: 'ri-box-3-line', label: '본체 재질', value: '엔지니어링 플라스틱', sub: '사출 성형 · 고강도 내구 구조' },
  { icon: 'ri-drop-fill', label: '패킹 재질', value: '고성능 실리콘', sub: '영구 일체형 · 분리 불가 설계' },
  { icon: 'ri-palette-line', label: '색상', value: '다크 차콜 그레이', sub: '현장 친화적 중립 컬러' },
  { icon: 'ri-layout-grid-2-line', label: '구조', value: '플립탑 힌지 커버', sub: '이중 압착 실링 시스템' },
  { icon: 'ri-archive-stack-line', label: '포장 단위', value: '100개 / 박스', sub: '현장 수급 효율 최적화' },
  { icon: 'ri-time-line', label: '내구성', value: '5년 이상 보증', sub: '장기 품질 보장 설계' },
  { icon: 'ri-flashlight-line', label: '시공 방식', value: '원스텝 (One-Step)', sub: '별도 실리콘 작업 불필요' },
  { icon: 'ri-shield-star-line', label: '특허', value: '출원 완료', sub: '출원번호 10-2024-0173136' },
];

const SpecsSection = () => {
  const refs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('opacity-100', 'translate-y-0');
        });
      },
      { threshold: 0.15 }
    );
    refs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="specs" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] text-sm font-semibold tracking-widest uppercase">Specifications</span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-bold text-[#1B2A4A] font-display">
            제품 스펙
          </h2>
          <p className="mt-4 text-gray-500 text-base max-w-xl mx-auto">
            엄격한 품질 기준으로 설계된 스마트캡의 주요 사양
          </p>
          <div className="mt-4 w-12 h-1 bg-[#FF6B35] mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
          {specs.map((spec, i) => (
            <div
              key={i}
              ref={(el) => { refs.current[i] = el; }}
              className="border border-gray-100 rounded-xl p-5 opacity-0 translate-y-6 transition-all duration-500 hover:border-[#FF6B35]/30 hover:shadow-sm group"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1B2A4A]/5 mb-3 group-hover:bg-[#FF6B35]/10 transition-colors">
                <i className={`${spec.icon} text-lg text-[#1B2A4A] group-hover:text-[#FF6B35] transition-colors`} />
              </div>
              <p className="text-gray-400 text-xs mb-1">{spec.label}</p>
              <p className="text-[#1B2A4A] font-bold text-sm leading-snug">{spec.value}</p>
              <p className="text-gray-400 text-xs mt-1">{spec.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecsSection;
